import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "has-text-centered" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Customer info")
], -1)
const _hoisted_3 = { class: "section" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "To help us to get to know our customers:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", null, "nb. all fields are optional")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_dropdown = _resolveComponent("v-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_v_input, {
        title: "Your Organisation?",
        type: "organisation",
        value: _ctx.organisation,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.organisation = $event)),
        error: _ctx.error('organisation')
      }, null, 8, ["value", "error"]),
      _createVNode(_component_v_dropdown, {
        title: "Your role within the Organisation?",
        btn_title: "Role",
        type: "role",
        value: _ctx.role,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.role = $event)),
        error: _ctx.error('role'),
        options: _ctx.roleList
      }, null, 8, ["value", "error", "options"]),
      _createVNode(_component_v_input, {
        title: "Your Organisation's Industry?",
        type: "industry",
        value: _ctx.industry,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.industry = $event)),
        error: _ctx.error('industry')
      }, null, 8, ["value", "error"]),
      _createVNode(_component_v_dropdown, {
        title: "Is your Organisation in the public or private sector?",
        btn_title: "Sector",
        type: "sector",
        value: _ctx.sector,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.sector = $event)),
        error: _ctx.error('sector'),
        options: _ctx.sectorList
      }, null, 8, ["value", "error", "options"]),
      _createVNode(_component_v_input, {
        title: "How did you learn about QRNG?",
        type: "introduction",
        value: _ctx.introduction,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.introduction = $event)),
        error: _ctx.error('introduction')
      }, null, 8, ["value", "error"])
    ])
  ]))
}